<template>
  <v-card flat>
    <v-card-text style="padding: 0px;margin: 0px;">
      <v-layout row wrap>
        <v-flex md12>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'TabBRKommentar',
    data() {
      return {}
    },
    methods: {
      myMethod: function () {
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabBRKommentar.vue